import styled from "styled-components";
import { Box, Flex, Image } from "rebass/styled-components";
import { Body, Title3 } from "../Text";
import { useHistory } from "react-router-dom";
import { analytics } from "MVVM/Analytics";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;
export function MobileAppAd() {
  const history = useHistory();
  return (
    <StyledBox variant="sidebar.new">
      <Flex flexDirection="column" style={{ gap: 15 }}>
        <HeroImage
          alignItems="flex-end"
          src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/mobile/mobile_apps.webp`}
        />
        <Flex flexDirection="column" style={{ gap: 5 }}>
          <StyledTitle3>
            Take the best of Allstar on the go with our mobile app!
          </StyledTitle3>
          <Body color="chalk">
            Create your best gaming moments and watch the latest highlights, all
            from the palm of your hand!
          </Body>
        </Flex>

        <AppsContainer>
          <AppImage
            src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/mobile/ios.webp`}
            onClick={() => {
              window.open(
                "https://apps.apple.com/us/app/allstar-play-share-star/id6476161266",
                "_blank",
              );
              analytics.track("Mobile App Download", {
                source: "Mobile Promo Unit",
                type: "ios",
              });
            }}
          />
          <AppImage
            src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/mobile/android.webp`}
            onClick={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.androidapp.gg.allstar",
                "_blank",
              );
              analytics.track("Mobile App Download", {
                source: "Mobile Promo Unit",
                type: "Android",
              });
            }}
          />
        </AppsContainer>
      </Flex>
    </StyledBox>
  );
}

const AppsContainer = styled(Flex)`
  width: 100%;
  gap: 10px;
`;

const AppImage = styled(Image)`
  width 100%;
  &:hover {
    cursor: pointer;
}
`;
const HeroImage = styled(Image)`
  border-radius: 5px;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breaks.small}) {
    width: 100%;
  }
`;

const StyledBox = styled(Box)`
  width: 100%;
`;

const StyledTitle3 = styled(Title3)`
  font-weight: 600;
`;
